import { namespace } from 's-vuex-class';
import { mixins, Watch, Options, Emit } from 'vue-property-decorator';
import PasswordMixin from '@/mixins/passwordMixin';

const notification = namespace('notification');

@Options({})
export default class ChangePasswordFormComponent extends mixins(PasswordMixin) {
  @notification.Action private readonly initNotificationError!: (message: string) => void;

  public oldPassword = '';
  public newPassword = '';
  public newPasswordRepeat = '';
  public isFormValid = false;

  get isValid() {
    if (this.isFormValid && this.newPassword === this.newPasswordRepeat) {
      return true;
    } else {
      return false;
    }
  }

  isRequired(value: string) {
    if (value) {
      return true;
    } else {
      return 'Required';
    }
  }

  isPasswordConfirmed() {
    if (this.newPassword === this.newPasswordRepeat) {
      return true;
    }
    return 'Passwords do not match';
  }

  public handleClickConfirm() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const form: any = this.$refs.form;
    if (form) {
      form.validate();
    }

    if (!this.isValid) {
      this.initNotificationError('Form is not correct');
      return;
    }
    this.$socket.emit('changePassword', {
      oldPassword: this.oldPassword,
      newPassword: this.newPassword,
    });

    this.sockets.subscribe('passwordUpdated', () => {
      this.close();
    });
  }

  @Emit('close')
  close(): void {
    return;
  }

  @Watch('newPassword')
  private handlerPasswordChange() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const confirmPass: any = this.$refs.confirmPass;
    if (confirmPass) {
      confirmPass.validate();
    }
  }
}
